export const QUESSION = 'quession';
export const GAME = 'game';
export const SERVER = 'server';
export const ROLE = 'role';
export const PAY_TYPE = 'payType';
export const AMOUNT = 'amount';
export const LOCATION = 'location';
export const PRODUCTION = 'production';
